import { HubspotServices as HubspotLogo } from '@clearkit/icons';

import hubspotTheme from './theme';

export default {
  logo: HubspotLogo,
  theme: hubspotTheme,
};
